<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteEmployeeDialog"
    :title="$t('employees.deleteTitle')"
    :confirm-text="$t('common.delete')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>{{ $t('employees.confirmDeleteMessage', { name: employeeName }) }}</p>
      <p class="text-danger">{{ $t('employees.irreversible') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const employeeName = ref('');
const employeeId = ref(null);

const open = (employee) => {
  employeeName.value = employee.username;
  employeeId.value = employee.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);
const handleConfirm = () => {
  emit('delete', employeeId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
